export default "__VITE_ASSET__4e3e592e__"